module.exports = __webpack_public_path__ + "static/media/gt-america-standard-medium.9bbe804e.woff";